/**
 * The studio, as the brand writes it: "Wally Tribeca".
 *
 * The server sends the bare neighbourhood — "Tribeca", "NoMad" — because that is what the row in
 * the ops console is called. On a screen it is a place name with no owner, and the one screen
 * where a member is reading it is the one where they are about to search a map for it or say it
 * to a receptionist. provider-kapi's own check-in flow prefixes the same way
 * (`CheckInLocationDto`), so this is the web's phrasing rather than a new one.
 *
 * Guarded, because a studio that is ever renamed "Wally Tribeca" upstream should not become
 * "Wally Wally Tribeca".
 */
export const studioTitle = (locationName?: string | null) => {
	const name = locationName?.trim()
	if (!name) {
		return 'Wally'
	}

	return name.toLowerCase().startsWith('wally') ? name : `Wally ${name}`
}
